import client from './client';

/**
 * Get branding configuration
 * @returns {Promise} Branding config object
 */
export const getBrandingConfig = async (tenantId = null) => {
  try {
    const url = tenantId ? `/branding/config?tenantId=${tenantId}` : '/branding/config';
    const response = await client.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update branding configuration
 * @param {FormData} formData - Form data with logo file and config fields
 * @returns {Promise} Updated branding config
 */
export const updateBrandingConfig = async (formData) => {
  try {
    const response = await client.put('/branding/config', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete logo from branding configuration
 * @returns {Promise} Success response
 */
export const deleteBrandingLogo = async () => {
  try {
    const response = await client.delete('/branding/logo');
    return response.data;
  } catch (error) {
    throw error;
  }
};
